import React from 'react';
import { useQuery } from 'react-apollo';

import useAuthenticated from '../../../../hooks/useAuthenticated';
import { MeQuery } from '../../../../graphql/queries/account';
import Spinner from '../../../../components/global/Spinner';
import ConsumerFeedbackModal from '../../../../components/global/ConsumerFeedbackModal';
import {
  isNativeAppWebView,
  postNativeAppConsumerFeedbackDismiss,
} from '../../../../services/native-bridge/native-apps-interface';

const ConsumerFeedbackView = () => {
  const authenticated = useAuthenticated();
  const isNative = isNativeAppWebView();
  const { data: { me: user } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  if (!user) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }
  return (
    <ConsumerFeedbackModal
      forceOpen
      dismissible={isNative}
      onClose={postNativeAppConsumerFeedbackDismiss}
    />
  );
};

export default ConsumerFeedbackView;
